
export default {
  props:{
    query: { type:Object, default: () => null },
  },
  watch:{
    '$props.query':{
      deep: true,
      immediate:true,
      handler(value){
        if(!!value) this.getData()
      }
    }
  },
  data: () => ({
    buttonList:[
      { label: '商品趋势', value: ['commodityCount', 'newCommodityCount'] },
      { label: '销售趋势', value: ['salesVolume', 'sales'] },
      { label: '直播趋势', value: ['anchorCount', 'liveCount'] },
      { label: '带货视频', value: ['opusAnchorCount', 'opusCount'] },
    ],
    chartDataApi: null,
    filter: ['commodityCount', 'newCommodityCount'],
  }),
  methods: {
    getData(){
      const shopId = this.$route.params?.id
      const params = this.$props.query
      this.$api.get(`/v2/shop/${shopId}/salesTrend`,{params}).
      then( res => this.chartDataApi = res?.data ).
      finally(() => {})
    }
  }
}